import React from 'react';
import GATracking, { EVENT_ACTION } from '.';

interface GaClickHOCProps {
  category: string;
  label: string;
  children: JSX.Element;
}

const GaClickHOC = ({ category, label, children }: GaClickHOCProps) => {
  return React.cloneElement(children, {
    onClick: () => {
      GATracking.event(category, EVENT_ACTION.CLICK, label);
      children.props.onClick && children.props.onClick();
    },
  });
};

export default GaClickHOC;
